<template>
  <div class="shop_list pointsMallShopList">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getStoreIntegral_pub({ type: 7 })">
      <van-tabs class="shop_menu" v-model="active" swipeable animated sticky @change="changeTabs">
        <van-tab v-for="(menu, index) in homeData_s?.cateogry" :key="menu.id + 'menu'" :tabindex="menu.id"
          :title="menu.cate_name">
          <div v-if="active == index" class="shop_list_content" style="margin-top: 0.3rem">
            <div v-for="item in getStoreIntegral_pubList" :key="item.id + 'category'">
              <router-link :to="'/pointsMall/detail?id=' + item.id + '&pid=' + item.sid">
                <div class="img">
                  <img :alt="item.store_name" :title="item.store_name" :src="item.image" />
                </div>
                <div class="text">
                  <p class="title clamp2">{{ item.store_name }}</p>
                  <p class="tag">
                    <van-progress style="padding: 0px !important" stroke-width="7" :percentage="((item.go_count || 0) / (item.all_count || 0)) * 100 >=
                        100
                        ? 100
                        : ((item.go_count || 0) / (item.all_count || 0)) * 100
                      " pivot-text="" color="linear-gradient(to right, #f8cb3e, #f7ce4d)" />
                  </p>
                </div>
              </router-link>
              <div class="text">
                <p class="integral">
                  剩余<span>{{ item.def_renshu }}</span>积分
                </p>
                <p class="price">
                  <span class="van-ellipsis" style="width: 50%">{{ item.integral }}<i>积分</i>
                  </span>
                  <em @click="
                    cartNum = 1
                  exchange_show = true;
                  exchangeData = item;
                  getUser();
                  ">
                    立即换取
                  </em>
                </p>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </van-list>
    <van-popup v-model="exchange_show" class="exchange">
      <div class="content_exchange">
        <div class="van-hairline--bottom">
          <div class="imgs">
            <img :src="exchangeData?.image || ''" :alt="exchangeData?.cate_name || ''" />
          </div>
          <div class="text" style="margin-left: 0.2rem">
            <p class="title van-multi-ellipsis--l2">
              {{ exchangeData?.cate_name || "" }}
            </p>
            <p class="van-ellipsis residue">
              本件剩余<i>{{ exchangeData?.def_renshu || 0 }}</i>积分
            </p>
          </div>
        </div>
        <div class="van-hairline--bottom operate">
          <p>
            账户积分<i>{{ userInfo?.integral || 0 }}</i>
          </p>
          <router-link to="/user/userBuy" v-if="userInfo?.integral <= 0">去获得积分</router-link>
          <input type="number" placeholder="请输入要换取的积分" v-else v-model="cartNum" @change="change"
            oninput="value=value.replace(/[^0-9.]/g,'')" />
        </div>
        <!-- 百分比 -->
        <div class="proportion" style="display: flex;">
          <span v-for="(item, index) in proportionData" :key="index + 'proportionData'"
            @click="changeProportion(exchangeData?.def_renshu || 0, item)" :style="{
              cursor: 'pointer', display: 'block', width: `calc((100% - 18px) / ${proportionData.length})`, marginRight: '.1rem', border: '1px solid #a6a6a6', color: '#a6a6a6', padding: '0.05rem 0.1rem', fontSize: '0.23rem', borderRadius: '20px',
              textAlign: 'center'
            }">{{ item.name }}</span>
        </div>
        <div class="check">
          <div class="btns">
            <button :disabled="userInfo?.integral <= 0"
              @click="playLuckAdd({ productId: exchangeData?.sid, new: 1 }, { def_renshu: exchangeData?.def_renshu || 0 })">
              确认换取
            </button>
          </div>
          <div style="color: var(--textColor2);text-align: center;display:flex;align-items: center;justify-content: center;">
            <van-icon name="question-o" @click="popup" style="margin-right: 0.1rem" />
            如被抢光自动换取最新一件
          </div>
        </div>
      </div>
      <van-icon class="colse" name="close" @click="exchange_show = false" />
    </van-popup>
  </div>
</template>

<script>
import sotreIntegralMixin from "@/Mixin/store_integral";
import api from "@/request/api";
export default {
  name: "shopCom",
  mixins: [sotreIntegralMixin],
  data() {
    return {
      exchangeData: null,
      dataList: [],
      active: 0,
      new_state: true,
      integral: 0,
      userInfo: null,
      homeData_s: {},
      requestCounter: 0
    };
  },
  mounted() {
    this.getStoreIntegral_pubList = [];
    this.homeData_s = this.homeData;
    this.homeData_s.cateogry.unshift({
      add_time: 1694502121,
      cate_name: "推荐",
      id: -1,
      is_index: 0,
      is_show: 1,
      pic: "",
      pid: 1,
      sort: 2
    });
  },
  props: {
    homeData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    change() {
      if (this.cartNum > this.exchangeData?.def_renshu) {
        this.cartNum = this.exchangeData?.def_renshu
      }
    },
    changeTabs(e) {
      if (this.homeData?.cateogry[e].cate_name != '推荐') {
        this.search.cate_id = this.homeData?.cateogry[e].id;
		 this.search.type = 8;
      } else {
		  this.search.cate_id = 0;
        this.search.type = 7;
      }
      this.finished = false;
      console.log(this.homeData?.cateogry[e])
      this.active = e;
      this.search.page = 1;
      this.getStoreIntegral_pubList = [];
      this.loading = true;
      this.getStoreIntegral_pub();
    },
    async getUser() {
      const result = await api.getUserinfo();
      if (result.status == 200) {
        this.userInfo = result.data;
      }
    },
  },
};
</script>
<style>
.pointsMallhome .main .shop_list .shop_list_content a .text .tag span {
  padding: 0px !important;
}

.pointsMallShopList .van-tabs__nav {
  background-color: transparent;
}
.van-icon-question-o{
  font-size: .3rem!important;
}
</style>
